@let fieldData = field();

<div class="mb-6">
  @if (fieldData.title) {
    <label
      class="block x-font-body-3 x-text-wf-title mb-2"
      [class.font-extrabold!]="fieldData.isHighlighted"
    >
      {{ fieldData.title }}
      @if (fieldData.helpText) {
        <tui-icon [tuiTooltip]="fieldData.helpText"></tui-icon>
      }
    </label>
  }

  <div class="p-3 x-white rounded-lg workflow-field-border">
    <a
      tuiLink
      [href]="fieldData.link"
      target="_blank"
      rel="noopener noreferrer"
      class="text-blue-700 hover:text-blue-800 x-font-body-4"
    >
      {{ fieldData.text }}
    </a>
  </div>
</div>
